export const getInfoFOItems = (t) => [
  {
    label: t('fleetTask.transferDeliveryModal.fields.fleetTaskNumber'),
    key: 'number',
  },
  {
    label: t('fleetTask.transferDeliveryModal.fields.fleetTaskStatus'),
    key: 'status.name',
  },
  {
    label: t('fleetTask.fields.licensePlate'),
    key: 'vehicle.license_plate',
  },
  {
    label: t('fleetTask.fields.driver'),
    key: 'driver_user.name',
  },
]
